<template>
  <main>
    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas">
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class="page-title">
            <span :style="`color: #149183`" >Actualizaciones </span>
          </div>
        </div>
        <div class="row">
          <div class="col offset-l2 l8">
            <div class="collection">
                <a v-for="(update, index) in listUpdates"  class="collection-item" :style="`color: #149183;`" @click="pushing(update.id)">
                <span v-if="index == 0" class="badge red" :style="`background-color: #149183 !important; color: white;`">
                  Nuevo
                </span>
                  {{ update.tittle }} ({{update.date}})
                </a>

            </div>
          </div>
        </div>


      </div>
    </div>
  </main>
</template>

<script>
import {mapState} from "vuex";
import listUpdates from "@/updates/listUpdates";

export default {
  name: "actualizaciones",
  data(){
    return {
      listUpdates: listUpdates
    }
  },
  methods:{
    pushing(id){
      this.$router.push({ name: `actualizacionesDetalle`, params: { id } })
    },
  },
  computed: {
    ...mapState(["image", "primaryColor", "darkenColor", "permisos"]),
  },
}
</script>

<style scoped>

.collection-item{
  cursor: pointer !important;
}

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
  both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}

.row {
  padding: 1rem;
}

</style>